<script>
import BaseListing from '../../../../share/ListingWithEditMode'
import clientObjectMixin from '../../../share/mixins/clientObjectMixin'

export default {
  mixins: [
    BaseListing,
    clientObjectMixin
  ],
  data () {
    return {
      service: this.$route.params.service,
      headerTitle: { title: 'Wymagalność kategorii załączników', description: 'Lista' },
      editModeUrlName: '',
      gridDataSource: null,
      gridName: 'grid_appraisal_task_attachment_category_requirement',
      editEventName: ''
    }
  },
  computed: {
    workflowId () { return this.$getCategoryNew(this.clientObject, this.$route.params.taskCategoryId).workflows[0].id },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: () => { return '' }
        },
        { id: 1, data: 'category', title: 'Kategoria' },
        { id: 2, data: 'taskCategory', title: 'Typ zlecenia rzeczoznawczego' },
        { id: 3, data: 'state', title: 'Stan' },
        { id: 4, data: 'role', title: 'Rola' }
      ]
    }
  },
  created () {
    this.getInitEditModeUrlName()
    this.getInitEditEventName()
    this.getInitGridDataSource()
  },
  methods: {
    getInitEditModeUrlName () {
      this.editModeUrlName = `${this.service}_appraisal_attachment_category_requirement_edit`
    },
    getInitEditEventName () {
      this.editEventName = `${this.service}:appraisal:attachmentCategoryRequirementEdit`
    },
    getInitGridDataSource () {
      this.gridDataSource = { service: this.service, url: `/attachment-category-requirements` }
    }
  }
}
</script>
